import { render, staticRenderFns } from "./MailForm.vue?vue&type=template&id=3fef1c73&scoped=true&"
import script from "./MailForm.vue?vue&type=script&lang=js&"
export * from "./MailForm.vue?vue&type=script&lang=js&"
import style0 from "./MailForm.vue?vue&type=style&index=0&id=3fef1c73&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fef1c73",
  null
  
)

export default component.exports